(function () {
  const SHIPPING_RETURNS_VERSION = '2026-09-us-usd-150-300';
  const SHIPPING_RETURNS_HTML = `
    <div class="one10-shipping-returns-copy">
      <section aria-labelledby="one10-shipping-heading">
        <h3 id="one10-shipping-heading">Australia &amp; New Zealand</h3>
        <ul>
          <li>Free standard shipping across Australia and New Zealand.</li>
          <li>Free express shipping on orders of $150 AUD or more.</li>
          <li>For orders below $150 AUD, express is available as a $15 AUD upgrade at checkout.</li>
          <li>Orders are typically processed within 1–2 business days. Tracking is emailed once dispatched.</li>
        </ul>
      </section>
      <section aria-labelledby="one10-international-shipping-heading">
        <h3 id="one10-international-shipping-heading">United States</h3>
        <p>Australia Post International Express.</p>
        <ul>
          <li>Orders below US$150: US$35 shipping.</li>
          <li>Orders from US$150 to US$299.99: US$20 shipping.</li>
          <li>Orders of US$300 or more: free express shipping.</li>
        </ul>
        <p>US shipping charges and thresholds are in US dollars. Thresholds apply to the merchandise subtotal after discounts. Delivery times vary by destination and customs clearance.</p>
      </section>
      <section aria-labelledby="one10-returns-heading">
        <h3 id="one10-returns-heading">Returns</h3>
        <ul>
          <li>Returns are accepted within 14 days of delivery.</li>
          <li>Items must be unused, unwashed and in original condition, with all tags and original packaging intact.</li>
          <li>Customers are responsible for return postage to ONE10.</li>
          <li>For an approved replacement garment, ONE10 covers the shipping cost of the replacement.</li>
        </ul>
        <p>To arrange a return, contact <a href="mailto:team@one10.au">team@one10.au</a>.</p>
      </section>
    </div>
  `;

  function getContent(header) {
    return header ? header.nextElementSibling : null;
  }

  function setAccordionState(header, open) {
    const content = getContent(header);
    if (!content) return;

    header.classList.toggle('active', open);
    header.setAttribute('aria-expanded', String(open));
    content.setAttribute('aria-hidden', String(!open));

    if (open) {
      content.style.marginTop = '1.8rem';
      content.style.marginBottom = '1.8rem';
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = '';
      content.style.marginTop = '';
      content.style.marginBottom = '';
    }
  }

  function toggleAccordion(header) {
    setAccordionState(header, !header.classList.contains('active'));
  }

  function initialiseAccordionAccessibility() {
    document.querySelectorAll('.wknd-product-accordion .wknd-accordion-header').forEach((header, index) => {
      const content = getContent(header);
      if (!content) return;

      header.type = 'button';

      if (!header.id) {
        header.id = `one10-product-accordion-heading-${index + 1}`;
      }

      if (!content.id) {
        content.id = `one10-product-accordion-content-${index + 1}`;
      }

      header.setAttribute('aria-controls', content.id);
      content.setAttribute('role', 'region');
      content.setAttribute('aria-labelledby', header.id);

      const isOpen = header.classList.contains('active');
      header.setAttribute('aria-expanded', String(isOpen));
      content.setAttribute('aria-hidden', String(!isOpen));

      if (isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  }

  function updateShippingAndReturns() {
    const accordion = document.getElementById('shipping-returns');
    if (accordion) {
      const header = accordion.querySelector('.wknd-accordion-header');
      const content = accordion.querySelector('.wknd-accordion-content');

      if (header) {
        const icon = header.querySelector('.icon');
        header.textContent = 'Shipping & Returns ';
        if (icon) header.appendChild(icon);
      }

      if (content && content.dataset.one10PolicyVersion !== SHIPPING_RETURNS_VERSION) {
        content.innerHTML = SHIPPING_RETURNS_HTML;
        content.dataset.one10PolicyVersion = SHIPPING_RETURNS_VERSION;

        if (header && header.classList.contains('active')) {
          window.requestAnimationFrame(() => {
            content.style.maxHeight = content.scrollHeight + 'px';
          });
        }
      }
    }

    document.querySelectorAll('.wknd-accr-links').forEach((wrapper) => {
      const links = wrapper.querySelectorAll('[data-accordion-link="shipping-returns"]');

      if (links[0]) {
        links[0].textContent = 'Free Standard Shipping AU/NZ';
        links[0].setAttribute('aria-label', 'View shipping information');
      }

      if (links[1]) {
        links[1].textContent = '14-Day Returns';
        links[1].setAttribute('aria-label', 'View return information');
      }

      wrapper.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('-')) {
          node.textContent = ' · ';
        }
      });
    });
  }

  function openAccordionById(accordionId) {
    const accordion = document.getElementById(accordionId);
    if (!accordion) return;

    const header = accordion.querySelector('.wknd-accordion-header');
    if (!header) return;

    accordion.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest'
    });

    window.setTimeout(() => {
      setAccordionState(header, true);
      header.focus({ preventScroll: true });
    }, 350);
  }

  function initialise() {
    updateShippingAndReturns();
    initialiseAccordionAccessibility();
  }

  document.addEventListener('click', function (event) {
    const header = event.target.closest('.wknd-product-accordion .wknd-accordion-header');
    if (header) {
      event.preventDefault();
      toggleAccordion(header);
      return;
    }

    const accordionLink = event.target.closest('[data-accordion-link]');
    if (accordionLink) {
      event.preventDefault();
      openAccordionById(accordionLink.getAttribute('data-accordion-link'));
      return;
    }

    const starRating = event.target.closest('[data-block-handle="star-rating"]');
    if (starRating) {
      event.preventDefault();
      openAccordionById('reviews');
    }
  });

  window.addEventListener('resize', function () {
    window.requestAnimationFrame(() => {
      document.querySelectorAll('.wknd-product-accordion .wknd-accordion-header.active').forEach((header) => {
        const content = getContent(header);
        if (content) content.style.maxHeight = content.scrollHeight + 'px';
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', initialise);
})();
